export default "__VITE_ASSET__43273f96__"